<div
  [class]="!uiFlowSession() || !instanceDataOpened() ? 'left-4' : '-left-20'"
  [style.z-index]="1007"
  class="flex flex-col absolute bg-white top-5 rounded-lg p-2 transition-all duration-300 ease-in-out will-change-[transform, left]"
>
  <a [routerLink]="['/']">
    <button
      pTooltip="Home"
      tooltipStyleClass="designerTooltip"
      flxButton
      variant="text"
      icon="center"
    >
      <img
        class="w-4 h-4"
        flxIcon
        alt="flowx logo"
        src="./assets/logo-small.svg"
      />
    </button>
  </a>
  <a [routerLink]="designerLink()">
    <button
      pTooltip="UI Designer"
      tooltipStyleClass="designerTooltip"
      flxButton
      variant="text"
      icon="center"
    >
      <i
        class="ph ph-paint-brush w-4 h-4 text-gray-800"
        flxIcon
      ></i>
    </button>
  </a>
  <a [routerLink]="uiFlowsLink()">
    <button
      pTooltip="UI Flows"
      tooltipStyleClass="designerTooltip"
      flxButton
      variant="text"
      icon="center"
    >
      <i
        class="ph ph-layout w-4 h-4 text-gray-800"
        flxIcon
      ></i>
    </button>
  </a>

  <button
    (click)="showInstanceData()"
    pTooltip="View UI Flow instance"
    flxButton
    variant="text"
    icon="center"
    data-testid="view-ui-flow-instance-btn"
  >
    <i
      class="ph ph-eye w-4 h-4 text-gray-800"
      flxIcon
    ></i>
  </button>
  <button
    (click)="showUiFlowInfo.set(!showUiFlowInfo())"
    clickStopPropagation
    flxButton
    variant="text"
    icon="center"
  >
    <i
      class="ph ph-info w-4 h-4 text-gray-800"
      flxIcon
    ></i>
  </button>
  @if (showUiFlowInfo()) {
    <ng-container>
      <flx-card
        [style.min-width.px]="400"
        [style.box-shadow]="'0px 4px 24px rgba(0, 0, 0, 0.24)'"
        class="flex flex-col absolute bg-white top-0 left-16 rounded-lg p-2 z-[2000]"
        cardStyle="raised"
      >
        <flx-reusable-template-info
          [reusableInfo]="reusableInfo()"
          (goToReusableTemplateClicked)="router.navigate(designerLink())"
        >
          Config UI Flow - UI Designer
        </flx-reusable-template-info>
      </flx-card>
    </ng-container>
  }
</div>

<react-wrapper
  [component]="FlxUiFlowRenderer"
  [props]="reactProps()"
/>
@if (instanceDataOpened() && uiFlowSession()) {
  <flx-ui-flow-session-details-panel
    [uiFlowSession]="uiFlowSession()"
    [processInstances]="uiFlowProcessInstances()"
    (sizeChange)="onSizeChange($event)"
    class="w-full h-full absolute left-0 bottom-0 z-[2000]"
    @fadeIn
  />
}
